import React from "react";
import PublicHeader from "./PublicHeader";
import PublicFooter from "./PublicFooter";
import Chatbot from "@/components/chatbot/Chatbot";
import { Outlet } from "react-router-dom";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
      <Chatbot />
    </div>
  );
}
